import axiosClient from "../../../../system/helpers/axiosConfig";

export const getProgramStatuses = () => {
  return axiosClient.get("api/admin/programs/statuses").then((r) => r.data);
};
